import template from 'url-template';
import URLEncodedFormData from 'utils/URLEncodedFormData';

const jsonMock = Promise.resolve({
  ok: true,
  json: () => ({}),
  text: () => '',
});

const buildResource = resource => {
  if (typeof resource === 'string') {
    return resource;
  } else if (resource.url) {
    const { url, ...variables } = resource;
    const parsedUrl = template.parse(url);

    return parsedUrl.expand(variables);
  }

  throw new Error(
    'Resource must be either a string or an object with a url template property and variables. ' +
      `Got ${resource}.`,
  );
};

const getContentType = body => {
  let contentType = 'application/json; charset=UTF-8';
  if (body instanceof FormData) {
    contentType = 'multipart/form-data; charset=UTF-8';
  } else if (body instanceof URLEncodedFormData) {
    contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
  }

  return contentType;
};

export const get = (resource, headers) => {
  // Jest doesn't like fetch
  if (process.env.NODE_ENV === 'test') return jsonMock;

  return fetch(buildResource(resource), {
    credentials: 'same-origin',
    headers: headers ? new Headers(headers) : {},
  });
};

export const post = (resource, body, headers) => {
  // Jest doesn't like fetch
  if (process.env.NODE_ENV === 'test') return jsonMock;

  let parsedBody;
  if (!body) {
    parsedBody = undefined;
  } else if (body && getContentType(body).includes('multipart/form-data')) {
    parsedBody = body;
  } else {
    parsedBody = body.toString();
  }

  return fetch(buildResource(resource), {
    method: 'POST',
    credentials: 'same-origin',
    body: parsedBody,
    headers: new Headers({
      'Content-Type': getContentType(body),
      ...headers,
    }),
  });
};

export const filePost = (resource, body, headers) => {
  // Jest doesn't like fetch
  if (process.env.NODE_ENV === 'test') return jsonMock;

  let parsedBody;
  if (!body) {
    parsedBody = undefined;
  } else if (body && getContentType(body).includes('multipart/form-data')) {
    parsedBody = body;
  } else {
    parsedBody = body.toString();
  }

  return fetch(buildResource(resource), {
    method: 'POST',
    credentials: 'same-origin',
    body: parsedBody,
    headers: new Headers({
      ...headers,
    }),
  });
};

export const filePut = (resource, body, headers) => {
  // Jest doesn't like fetch
  if (process.env.NODE_ENV === 'test') return jsonMock;

  let parsedBody;
  if (!body) {
    parsedBody = undefined;
  } else if (body && getContentType(body).includes('multipart/form-data')) {
    parsedBody = body;
  } else {
    parsedBody = body.toString();
  }

  return fetch(buildResource(resource), {
    method: 'PUT',
    credentials: 'same-origin',
    body: parsedBody,
    headers: new Headers({
      ...headers,
    }),
  });
};

export const put = (resource, body, headers) => {
  // Jest doesn't like fetch
  if (process.env.NODE_ENV === 'test') return jsonMock;

  return fetch(buildResource(resource), {
    method: 'PUT',
    credentials: 'same-origin',
    body: body ? body.toString() : undefined,
    headers: new Headers({
      'Content-Type': getContentType(body),
      ...headers,
    }),
  });
};

export const del = (resource, headers) => {
  // Jest doesn't like fetch
  if (process.env.NODE_ENV === 'test') return jsonMock;

  return fetch(buildResource(resource), {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: headers ? new Headers(headers) : {},
  });
};

/*export const getComponent = spec => {
  // Jest doesn't like fetch
  if (process.env.NODE_ENV === 'test') return jsonMock;

  return get({
    url: `${COMPONENTS_SECURE_URL}{?query*}`,
    query: spec,
  });
};
*/
